import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import store from '@/store/index.js'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@/assets/css/main.less'
import '@/assets/css/theme.less'
import '@/assets/css/iconfont/iconfont.css'
import {components} from '@/utils/component.js'
import VConsole from 'vconsole';
// const vConsole = new VConsole();
const app = createApp(App)


app.use(Antd)
app.use(router)
app.use(store)
app.use(components)
// app.use(vConsole)
app.mount('#app')
